import React from 'react';
import { Switch, Route, Redirect } from 'react-router';

import AuthOrApp from './authOrApp'
import Dashboard from '../dashboard/dashboard';
import Usuario from '../usuario/usuario';
import UsuarioImobiliaria from '../usuario/usuarioImobiliaria';
import Imobiliaria from '../imobiliaria/imobiliaria';
import Cadastro from '../cadastro/cadastro';
import Empreendimento from '../empreendimento/empreendimento';
import Unidade from '../unidade/unidade';
import UnidadeSimulacao from '../unidade/unidadeSimulacao';
import UnidadeReserva from '../unidade/unidadeReserva';

export default props => (
	<div id='id-content-wrapper' className='content-wrapper' >
		<Switch>
			<Route exact path='/' component={Dashboard} />
			{(props.usuarioCarregado && props.usuarioCarregado.administrador) &&
			<Route path='/usuario' component={Usuario} />}

			{(props.usuarioCarregado && props.usuarioCarregado.imobiliaria) &&
			<Route path='/usuarioImobiliaria' component={UsuarioImobiliaria} />}

			{(props.usuarioCarregado && props.usuarioCarregado.administrador) &&
			<Route path='/imobiliaria' component={Imobiliaria} />}
			{(props.usuarioCarregado && props.usuarioCarregado.administrador) &&
			<Route path='/cadastro' component={Cadastro} />}

			<Route path='/empreendimento' component={Empreendimento} />

			{(props.usuarioCarregado && props.usuarioCarregado.administrador) &&
			<Route path='/unidade' component={Unidade} />}

			<Route path='/unidadeSimulacao' component={UnidadeSimulacao} />

			{(props.usuarioCarregado && props.usuarioCarregado.administrador) &&
			<Route path='/unidadeReserva' component={UnidadeReserva} />}

			<Redirect from='*' to='/' />
		</Switch>
	</div>
);